<!-- 商品管理 V2 方案 - 系统 OPTION 选择弹窗 -->
<template>
  <el-dialog
    title="附加服务"
    :visible.sync="visible"
    width="600px"
    append-to-body
    center
    :close-on-click-modal="false"
    custom-class="system-option-dialog"
  >
    <div v-loading="loading" class="system-option-list">
      <div class="option-grid table-head">
        <div>附加服务选择</div>
        <div>附加服务日文名</div>
        <div>收费标准</div>
      </div>
      <div v-for="(option, index) in visibleList" :key="option.name || index" class="option-grid table-row">
        <div class="option-choice"><el-checkbox v-model="option.checked" /><span>({{ index + 1 }}) {{ option.name }}</span></div>
        <div>{{ option.name_ja || option.name_translate }}</div>
        <div>{{ option.price }} {{ option.unit }}</div>
      </div>
      <div v-if="!loading && !list.length" class="empty">暂无数据</div>
    </div>
    <el-button v-if="list.length > 9" class="more-button" size="small" @click="showMore = !showMore">
      {{ showMore ? '收起OPTION' : '查看更多OPTION' }}
    </el-button>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-button" @click="confirm">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
/**
 * 从 orderOptionList 拉取系统预设 OPTION
 * 勾选后回传给 optionSettings 追加到方案
 */
export default {
  name: 'SystemOptionDialog',
  data() {
    return {
      visible: false,
      loading: false,
      showMore: false, // 是否展开全部（默认展示前 9 条）
      list: []
    }
  },
  computed: {
    // 折叠时只展示前 9 条
    visibleList() {
      return this.showMore ? this.list : this.list.slice(0, 9)
    }
  },
  methods: {
    // 拉取系统 OPTION 并标记已选中的项
    async open(selected, userId) {
      this.visible = true
      this.showMore = false
      this.loading = true
      try {
        const res = await this.$api.orderApi.orderOptionList({
          need_fix: 1,
          user_id: userId
        })
        this.list = res.data.map(option => ({
          ...option,
          checked: selected.some(item => item.name === option.name)
        }))
      } finally {
        this.loading = false
      }
    },
    // 回传勾选的 OPTION：系统 option 使用旧字段，方案保存接口使用新字段
    confirm() {
      const options = this.list.filter(option => option.checked).map(option => {
        const { id, checked, name_translate, image_ext, video_ext, file_ext, remark_ext, ...data } = option
        return {
          ...data,
          checked: true,
          name_ja: data.name_ja != null ? data.name_ja : (name_translate || ''),
          images: data.images || image_ext || [],
          videos: data.videos || video_ext || [],
          files: data.files || file_ext || [],
          work_seconds: data.work_seconds == null ? '' : data.work_seconds,
          special_requirement: data.special_requirement != null
            ? data.special_requirement
            : (remark_ext || '')
        }
      })
      this.$emit('confirm', options)
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.system-option-list { min-height: 180px; overflow: hidden; }
.option-grid { display: grid; grid-template-columns: 1.35fr 1.35fr .85fr; }
.option-grid > div { box-sizing: border-box; display: flex; align-items: center; justify-content: center; min-width: 0; padding: 12px; }
.table-head { min-height: 40px; border-radius: 4px 4px 0 0; background: #f8f8f8; }
.table-row { min-height: 41px; border-bottom: 1px solid #ebeef5; color: #606266; }
.option-choice { justify-content: flex-start !important; gap: 10px; }
.option-choice .el-checkbox { margin: 0; }
.more-button { margin-top: 10px; border-color: #b4272d; background: #b4272d; color: #fff; font-weight: 700; }
.empty { padding: 48px; color: #909399; text-align: center; }
.dialog-footer { display: block; padding-top: 28px; text-align: center; }
.save-button { width: 70px; border-color: #b4272d; background: #b4272d; color: #fff; }
</style>

<style lang="scss">
.system-option-dialog .el-dialog__body { padding: 18px 24px 0; }
.system-option-dialog .el-dialog__footer { padding-bottom: 18px; }
</style>
